import { useRef, useState, useContext } from "react";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { TopikTestContext } from "./TakeTest";
import QUESTION_TYPE from "../../../constants/question-type";
import { InputTextarea } from "primereact/inputtextarea";
import { modifyMediaUrl } from "../../../helpers/modifyMediaUrl";
import topikQuestionHeadingIcon from "../../../stories/assets/topik-question-heading-icon.svg";

export default function TestQuestion({ questionGroups, isSubmitted }) {
  let GLOBAL_QUESTION_INDEX = 1;
  const { translation } = useContext(TopikTestContext);

  return (
    <>
      {questionGroups.map((group) => {
        let startIndex = GLOBAL_QUESTION_INDEX;
        const endIndex = startIndex + group.questions.length - 1;
        return (
          <div key={group.id}>
            <div className="flex gap-3 align-items-center mb-3">
              <div className="topik-question-heading-icon-wrapper">
                <img src={topikQuestionHeadingIcon} alt="" />
              </div>
              <h5 className="keduall-typography heading-h5-bold-700 text-default-txt-color">
                {startIndex !== endIndex ? <span>{`[${String(startIndex).padStart(2, "0")}~${String(endIndex).padStart(2, "0")}] `}</span> : null}
                <span dangerouslySetInnerHTML={{ __html: group.title }}></span>
              </h5>
            </div>

            {group.questions.map((question) => {
              const currentQuestionIndex = GLOBAL_QUESTION_INDEX++;
              return (
                <div key={question.id} className="mb-3 p-2" id={`question_${question.id}`}>
                  <div>
                    <h5 className="keduall-typography heading-h5-semibold-600 flex gap-2 text-default-txt-color">
                      <span>{`${String(currentQuestionIndex).padStart(2, "0")}. `}</span>
                      <span dangerouslySetInnerHTML={{ __html: question.content }}></span>
                    </h5>
                  </div>

                  {question?.audioUrl && <QuestionAudio audioUrl={question?.audioUrl} />}

                  {question?.imageUrl && <img src={modifyMediaUrl(question?.imageUrl)} alt="question" className="pt-3" />}

                  <QuestionAnswer answers={question.answers} questionType={question?.questionTypeCode} isSubmitted={isSubmitted} questionId={question.id} />
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
}

function QuestionAudio({ audioUrl }) {
  const audioRef = useRef(null);
  return (
    <div className="relative my-3">
      <audio ref={audioRef} controls className="w-full">
        <source src={modifyMediaUrl(audioUrl)} type="audio/mp3" />
        <source src={modifyMediaUrl(audioUrl)} type="audio/ogg" />
        <source src={modifyMediaUrl(audioUrl)} type="audio/wav" />
      </audio>
      <div class="absolute audio-custom"></div>
    </div>
  );
}

function QuestionAnswer({ answers, questionType, isSubmitted, questionId }) {
  const { selectedAnswer, onSelectAnswer } = useContext(TopikTestContext);

  const isChecked = (answer) => {
    return selectedAnswer[answer.questionId] === answer.id || answer.userSelect;
  };

  return (
    <>
      {questionType === QUESTION_TYPE.WRITING ? (
        <div className="mr-3 mt-3">
          <InputTextarea
            className="w-full h-10rem"
            cols={30}
            disabled={isSubmitted}
            onChange={(e) => {
              onSelectAnswer({
                questionId: questionId,
                userAnswer: e.target.value,
              });
            }}
          />
        </div>
      ) : (
        <div className="my-3">
          {answers.map((answer, index) => {
            return (
              <div key={answer.id}>
                <div className="p-2 flex justify-content-between align-items-center">
                  <div>
                    <label
                      htmlFor={`answer_${answer.id}`}
                      className={`topik-doing-test-checkbox-label cursor-pointer select-none flex align-items-center ${isChecked(answer) ? "checked" : ""}`}
                    >
                      <Checkbox
                        inputId={`answer_${answer.id}`}
                        checked={isChecked(answer)}
                        className="topik-doing-test-checkbox"
                        onChange={() => {
                          onSelectAnswer({
                            answerId: answer.id,
                            questionId: answer.questionId,
                          });
                        }}
                        disabled={isSubmitted}
                      ></Checkbox>
                      {answer?.imageUrl ? (
                        <div className="flex gap-3 align-items-center">
                          <div className="question-answer-number keduall-typography heading-h6-normal-400">
                            <span>{index + 1}</span>
                          </div>
                          <img src={modifyMediaUrl(answer.imageUrl)} alt={index + 1} />
                        </div>
                      ) : (
                        <h6 className="keduall-typography heading-h6-normal-400">
                          <div className="question-answer-number">
                            <span>{index + 1}</span>
                          </div>
                          <span className="question-answer-text">{answer?.answer}</span>
                        </h6>
                      )}
                    </label>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
